import SectionTop from './SectionTop';
// import SectionBottom from './SectionBottom';
// import SectionCenter from './SectionCenter';
function Footer() {
  return (
    <div className="footer-wrapper">
      <ogpu-footer/>
      <SectionTop/>
    </div>
  );
}

export default Footer;
